:host {
  display: block;
  height: 72px;
  min-width: 272px;
  max-width: 400px;
}

/* Base styles */
.dc-ddl {
  font-family: var(--dc-font-family);
  font-weight: 400;
  font-size: 16px;
  display: block;
  position: relative;
  min-width: 272px;
  max-width: 400px;
}

.dc-ddl-input {
  min-width: 180px;
  height: 49px;
  border: none;
  outline: none;
  margin: 1px;
  box-sizing: border-box;
  caret-color: var(--dc-primary-colour);
  color: var(--dc-primary-text-color);
  font-family: var(--dc-font-family);
  font-weight: 400;
  font-size: 16px;
  padding: 0;
  background-color: var(--dc-background-colour);
  text-overflow: ellipsis;
}

.dc-ddl-input::placeholder {
  color: var(--dc-accent-text-color);
}

.dc-ddl-select {
  visibility: hidden;
  height: 0;
  padding: 0;
  margin: 0;
}

.dc-ddl-control {
  height: 52px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  outline: 3px solid transparent;
  border: 1px solid var(--dc-ui-border-default);
  border-radius: 8px;
  padding: 14px 16px;
  cursor: pointer;
}

.dc-ddl-label {
  background-color: var(--dc-background-colour);
  border: 0;
  color: var(--dc-primary-text-color);
  display: inline-block;
  left: 12px;
  line-height: 22px;
  margin: 0;
  padding: 0 4px;
  position: absolute;
  top: 14px;
  transition: all 0.3s;
  cursor: pointer;
}

.dc-ddl-list {
  background-color: var(--dc-background-colour);
  border: 2px solid var(--dc-primary-colour);
  border-radius: 8px;
  box-sizing: border-box;
  display: none;
  left: 0;
  overflow: hidden;
  padding-bottom: 4px;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 10;
}

.dc-ddl-list-area {
  display: flex;
  height: 49px;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;
}

.dc-ddl-combo-placeholder {
  line-height: 52px;
  display: block;
  color: var(--dc-accent-text-color);
  font-size: 16px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.dc-ddl-combo-count {
  color: var(--dc-primary-text-color);
  font-size: 16px;
}

.dc-ddl-combo-count pre {
  display: inline-block;
  font-weight: 600;
  font-family: var(--dc-font-family);
  color: var(--dc-primary-text-color);
}

.dc-ddl-options {
  min-height: 52px;
  max-height: 208px;
  overflow-y: scroll;
  overflow-x: hidden;
  outline: none;
  box-sizing: border-box;
  background-color: var(--dc-background-colour);
}

.dc-ddl-buttons {
  display: flex;
  justify-content: flex-end;
  align-items: flex-start;
  margin-left: auto;
}

.dc-ddl-list-btns {
  padding-bottom: 2px;
}

.dc-ddl-clear-btn {
  display: none;
  margin-right: 24px;
  cursor: pointer;
}

.dc-ddl-clear-filter-btn {
  display: flex;
  cursor: pointer;
  height: 16px;
  margin-right: 42px;
}

.dc-ddl-open .dc-ddl-clear-btn {
  margin-right: 42px;
}

.dc-ddl-clear-icon {
  width: 16px;
  height: 16px;
}

.dc-ddl-clear-icon path {
  fill: var(--dc-primary-text-color);
}

.dc-ddl-open-btn {
  display: flex;
  align-items: center;
  width: 16px;
  height: 16px;
}

.dc-ddl-chevron {
  width: 16px;
  height: 10px;
  transition: all 0.3s;
}

.dc-ddl-chevron path {
  fill: var(--dc-primary-colour);
}

/* animation  */
.dc-ddl-open .dc-ddl-chevron {
  transform: rotate(180deg);
}

.dc-ddl-open-btn .dc-ddl-chevron {
  z-index: 20;
}

.dc-ddl-open .dc-ddl-open-btn {
  margin-right: 18px;
}

.dc-ddl-selected-option pre {
  font-weight: 600;
  font-family: var(--dc-font-family);
  font-size: 16px;
}

.dc-ddl-selected-option pre::after {
  content: " selected";
  font-weight: 400;
}

/* Hover states */
.dc-ddl-view .dc-ddl-control:hover,
.dc-ddl-selected .dc-ddl-control:hover {
  border: 1px solid var(--dc-primary-accent-colour);
}

.dc-ddl-view .dc-ddl-control:focus-visible,
.dc-ddl-selected .dc-ddl-control:focus-visible {
  outline: 3px solid var(--dc-primary-colour);
  outline-offset: 1px;
}

.dc-ddl-open .dc-ddl-control:focus-visible {
  outline: none;
}

/* Selected mode */
.dc-ddl-selected .dc-ddl-label {
  font-size: 12px;
  top: -6px;
  line-height: 16px;
}

.dc-ddl-selected .dc-ddl-control {
  border: 1px solid var(--dc-ui-border-default);
  border-radius: 8px;
  padding: 14px 16px;
}

.dc-ddl-selected .dc-ddl-clear-btn {
  display: block;
  width: 16px;
  height: 16px;
}

.dc-ddl-selected-option {
  color: var(--dc-primary-text-color);
  width: 80%;
}

/* Open mode */
.dc-ddl-open .dc-ddl-list {
  display: block;
}

.dc-ddl-open .dc-ddl-selected-option {
  display: none;
}

.dc-ddl-open .dc-ddl-label {
  font-size: 12px;
  top: -6px;
  line-height: 16px;
  z-index: 20;
}

.dc-ddl-open .dc-ddl-control {
  border: 1px solid transparent;
  margin: 0;
  padding: 0;
}

/* Disabled */
.dc-ddl-disabled .dc-ddl-control {
  border-color: var(--dc-ui-disabled-border);
  cursor: not-allowed;
}

.dc-ddl-disabled .dc-ddl-label,
.dc-ddl-disabled .dc-ddl-selected-option {
  color: var(--dc-greyscale-04);
  cursor: not-allowed;
}

.dc-ddl-disabled .dc-ddl-view-btns svg path {
  fill: var(--dc-greyscale-04);
}

.dc-ddl-disabled .dc-ddl-control:hover {
  border-color: var(--dc-ui-disabled-border);
}

.dc-ddl-disabled .dc-ddl-control:focus-visible {
  outline: none;
}

/* Error state */
.dc-ddl-error-msg {
  display: none;
  color: var(--dc-primary-error-color);
  font-size: 12px;
  padding: 4px 0 0 14px;
  white-space: pre-wrap;
  margin: 0;
  outline: none;
}

.dc-ddl-error .dc-ddl-control {
  border: 1px solid var(--dc-primary-error-color);
}

.dc-ddl-error .dc-ddl-error-msg:not(:empty) {
  display: block;
}

.dc-ddl-disabled .dc-ddl-option {
  color: var(--dc-greyscale-04);
  cursor: not-allowed;
  pointer-events: none;
}
